export const levels = [
    { name: 'trace', color: 'lightgray', icon: '✏️', consoleMethod: 'trace' },
    { name: 'debug', color: 'green', icon: '🐸', consoleMethod: 'debug' },
    { name: 'info', color: 'lightblue', icon: '🔵', consoleMethod: 'info' },
    { name: 'warn', color: 'orange', icon: '⚠️', consoleMethod: 'warn' },
    { name: 'error', color: 'red', icon: '‼️', consoleMethod: 'error' },
];
export const isLevelActive = (queryLevel, targetLevel) => {
    if (!targetLevel) {
        return true;
    }
    const targetLevelIndex = levels.findIndex(l => l.name === targetLevel);
    const queryLevelIndex = levels.findIndex(l => l.name === queryLevel);
    return queryLevelIndex >= targetLevelIndex;
};
export default levels;
//# sourceMappingURL=levels.js.map